import { Card } from "@/components/ui/card";

import LeadCollectionForm from "../../lead-collection/lead-collection-form";

const LeadsHeader = () => {
    return (
        <Card className="col-span-3 flex flex-col items-center justify-between gap-4 border p-6 shadow-none md:flex-row">
            <h3 className="text-lg font-semibold text-gray-700">Collect the Emails of Visitors Who Talk to the Chat for Marketing</h3>
            {/* <Button
        size={'lg'}
        className="w-full bg-blue-50 text-lg font-semibold text-gray-600 shadow-none hover:bg-blue-100 md:w-auto"
      >
        Customize Lead
      </Button> */}
            <LeadCollectionForm />
        </Card>
    );
};

export default LeadsHeader;
